import {useDispatch} from "react-redux";
import {useHistory} from "react-router-dom";
import {setLeftNavigation} from "../../actions/navigationActions";
import {ClickableText, CustomContainer, CustomDivider} from "../../components/custom-common";
import {Icon} from "semantic-ui-react";

const MfaReminder = () => {
    const history = useHistory();
    const dispatch = useDispatch();

    const setUpMfa = () => {
        dispatch(setLeftNavigation(false));
        history.push({ pathname: '/mfa'});
    }

    return(
        <CustomContainer basic className={'mfaReminder'}>
            <div className={"smaller"}><b>Reminder</b></div>
            <div className={'smaller'}>Two-factor authentication is not enabled yet. Add an additional
                layer of security to your account.</div>
            <CustomDivider smaller hidden/>
            <ClickableText onClick={setUpMfa}>
                Set it up <Icon name={'long arrow alternate right'} />
            </ClickableText>
        </CustomContainer>
    )
}

export default MfaReminder